import axiosInstance from "./api_helper";

export const createReglement = async (reglement) => {
  try {
    const response = await axiosInstance.post('/api/reglements', JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReglement = async (id, reglement) => {
  try {
    const response = await axiosInstance.put(`/api/reglements/${id}`, JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReglements = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/api/reglements', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEcheancesClients = async ({ clientId, dateFrom, dateTo, statut }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    const response = await axiosInstance.get('/api/reglements/client/echeance', { params });
    return response;
  } catch (error) {
    throw error;
  }
};


export const getCautionsClients = async ({ clientId, dateFrom, dateTo, statut }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    const response = await axiosInstance.get('/api/reglements/client/caution', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const encaisserReglement = async (id, encaissement) => {
  try {
    const response = await axiosInstance.post(`/api/reglements/${id}/encaisser`, JSON.stringify(encaissement));
    return response;
  } catch (error) {
    throw error;
  }
}

export const getReglementsByInvoice = async (numero) => {
  return await axiosInstance.get(`/api/reglements/facture?numero=${encodeURIComponent(numero)}`);
};

export const getReglementById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/reglements/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteReglement = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/reglements/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReglementsByClient = async (clientId, page = 0, size = 20, sortBy = 'dateReglement', sortDirection = 'desc') => {
  try {
    const response = await axiosInstance.get(`/api/reglements/client/${clientId}`, {
      params: { page, size, sortBy, sortDirection }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const rechercherReglements = async ({ clientId, chantierId, dateFrom, dateTo, statut, query }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    if (query) params.query = query;

    const response = await axiosInstance.get('/api/reglements/rechercher', { params });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFacturesImpayees = async (clientId) => {
  try {
    const response = await axiosInstance.get(`/api/factures/impayees/${clientId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBonLivraisonsNonRegles = async (clientId) => {
  try {
    const response = await axiosInstance.get(`/api/bon-livraisons/non-regles/${clientId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
